import { NgModule } from '@angular/core';
import { Routes, RouterModule } from "@angular/router";
import { LoginPageComponent } from './login/login-page.component';
import { MailRedirectHandlerComponent } from './mail-redirect-handler/mail-redirect-handler.component';

export const authenticationRoutes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginPageComponent
    },
    {
        path: 'mail-redirect-handler',
        component: MailRedirectHandlerComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(authenticationRoutes)],
    exports: [RouterModule]
})

export class AuthenticationRoutingModule {
}
